import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center",
  style: {"height":"300px"}
}
const _hoisted_2 = {
  key: 1,
  class: "flex items-center gap-6 flex-col text-left m-3 sm:m-0"
}
const _hoisted_3 = { class: "flex justify-between w-full items-center mt-2 gap-2" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = { class: "block truncate" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }
const _hoisted_7 = {
  style: {"max-height":"calc(100vh - 300px)"},
  class: "overflow-y-auto border-b border-gray-200 shadow sm:rounded-lg"
}
const _hoisted_8 = { class: "table-fixed w-full divide-y divide-gray-200" }
const _hoisted_9 = { class: "bg-gray-50" }
const _hoisted_10 = { class: "sm:px-6 pl-2 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500" }
const _hoisted_11 = {
  class: "sm:px-6 px-2 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500",
  style: {"width":"130px"}
}
const _hoisted_12 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_13 = { class: "sm:px-6 pl-2 py-3 sm:text-sm text-xs break-words" }
const _hoisted_14 = {
  class: "sm:px-6 px-2 py-3 sm:text-sm text-xs",
  style: {"width":"130px"}
}
const _hoisted_15 = {
  key: 2,
  style: {"height":"300px"},
  class: "flex items-center justify-center text-gray-600"
}

import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from "@headlessui/vue";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/vue/20/solid";
import { usePublicHolidays } from "@oculai/planner";
import { format, getYear } from "date-fns";
import { computed, PropType, ref } from "vue";
import { useI18n } from "vue-i18n";
import LoadingSpinner from "@/components/loading_state/LoadingSpinner.vue";
import ModalTW from "@/components/modals/ModalTW.vue";
import { apiClient } from "@/repositories/clients";
import { Project } from "@/types/Project";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicHolidaysModal',
  props: {
  project: {
    type: Object as PropType<Project>,
    required: true,
  },
},
  emits: ["commit", "close"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const years = computed(() => {
  const startYear = getYear(props.project.planned_start) - 1;
  const endYear = Math.max(getYear(props.project.planned_end) + 1, startYear);
  const interval = endYear - startYear + 1;
  return [...Array(interval).keys()].map((key) => (key + startYear).toString());
});

const currentYear = getYear(new Date());

const selectedYear = ref(
  years.value.includes(currentYear.toString())
    ? currentYear.toString()
    : years.value[years.value.length - 1],
);

const emit = __emit;

const { publicHolidaysResponse, arePublicHolidaysLoading } = usePublicHolidays(
  props.project.country_code,
  props.project.zip_code,
  computed(() => parseInt(selectedYear.value)),
  apiClient,
);

const handleApplyClick = () => {
  emit("commit", publicHolidaysResponse.value?.holidays);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalTW, {
    open: true,
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('close'))),
    customCls: "m-4 w-full min-w-[250px] sm:w-2/3 xl:w-1/3"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        (_unref(arePublicHolidaysLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(LoadingSpinner)
            ]))
          : (_unref(publicHolidaysResponse) && _unref(publicHolidaysResponse)?.holidays.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)("admin.durations_project_settings.public_holidays_for")) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(__props.project.zip_code) + " " + _toDisplayString(_unref(publicHolidaysResponse)?.locality_name), 1),
                    _createTextVNode(" (" + _toDisplayString([_unref(publicHolidaysResponse)?.state, __props.project.country_code]
                  .filter((item) => item)
                  .join(", ")) + ") ", 1)
                  ]),
                  _createVNode(_unref(Listbox), {
                    as: "div",
                    modelValue: selectedYear.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_unref(ListboxButton), { class: "relative w-full cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-yellow-600 sm:text-sm sm:leading-6" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_5, _toDisplayString(selectedYear.value), 1),
                            _createElementVNode("span", _hoisted_6, [
                              _createVNode(_unref(ChevronUpDownIcon), { class: "h-5 w-5 text-gray-400" })
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_Transition, {
                          "leave-active-class": "transition ease-in duration-100",
                          "leave-from-class": "opacity-100",
                          "leave-to-class": "opacity-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ListboxOptions), { class: "absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm" }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                                  return (_openBlock(), _createBlock(_unref(ListboxOption), {
                                    as: "template",
                                    key: year,
                                    value: year
                                  }, {
                                    default: _withCtx(({ active, selected }) => [
                                      _createElementVNode("li", {
                                        class: _normalizeClass([
                          active ? 'bg-yellow-600 text-white' : 'text-gray-900',
                          'relative cursor-default select-none py-2 pl-3 pr-9',
                        ])
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass([selected ? 'font-semibold' : 'font-normal', 'block truncate'])
                                        }, _toDisplayString(year), 3),
                                        selected
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: _normalizeClass([
                            active ? 'text-white' : 'text-yellow-600',
                            'absolute inset-y-0 right-0 flex items-center pr-4',
                          ])
                                            }, [
                                              _createVNode(_unref(CheckIcon), {
                                                class: "h-5 w-5",
                                                "aria-hidden": "true"
                                              })
                                            ], 2))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("table", _hoisted_8, [
                    _createElementVNode("thead", _hoisted_9, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_10, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_name")), 1),
                        _createElementVNode("th", _hoisted_11, _toDisplayString(_unref(t)("admin.durations_project_settings.holidays_field_date")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publicHolidaysResponse)?.holidays, (holiday) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: holiday.name,
                          class: "text-gray-800"
                        }, [
                          _createElementVNode("td", _hoisted_13, _toDisplayString(holiday.name), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(format)(holiday.start_date, "dd.MM.yyyy")), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: handleApplyClick,
                  class: "flex gap-2 items-center justify-center focus:outline-none w-full rounded-md bg-yellow-500 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-yellow-600 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 whitespace-nowrap"
                }, _toDisplayString(_unref(t)("buttons.apply")), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createTextVNode(_toDisplayString(_unref(t)("admin.durations_project_settings.no_public_holiday_message")) + "  ", 1),
                _createElementVNode("b", null, _toDisplayString(__props.project.zip_code), 1),
                _createTextVNode(" (" + _toDisplayString(__props.project.country_code) + ") ", 1)
              ]))
      ])
    ]),
    _: 1
  }))
}
}

})